import { InputAdornment, OutlinedInput, useTheme } from "@mui/material";
import { Parser } from "expr-eval";
import _ from "lodash";
import { useEffect, useState } from "react";
import { getInterpolatedColor } from "../common/util";
import { activityApi } from "./activity.queries";

export default function ActivityScoreInput(props) {
	const useUpdate = activityApi.useUpdate();
	const theme = useTheme();
	const [activity, setActivity] = useState(props.activity);

	useEffect(() => {
		setActivity(props.activity);
	}, [props.activity]);

	const updateActivity = async (updated) => {
		if (updated.scoreRaw) {
			try {
				const expression = Parser.parse(updated.scoreRaw);
				const result = expression.evaluate();
				if (_.isNumber(result)) {
					updated.score = result < 1.9 ? result * 100 : result;
					updated.status = 'Completed';
					updated.completeness = 100;
				}
			}
			catch (e) {
				updated.score = null;
			}
		}
		setActivity({ ...updated });
		await useUpdate.mutateAsync(updated);
	}
	const debouncedUpdateActivity = _.debounce(updateActivity, 500);

	const keyDown = (e) => {
		if(e.key == 'ArrowDown' || e.key == 'ArrowUp'){
			const delta = e.key == 'ArrowDown' ? 1 : -1;
			const siblings = document.querySelectorAll('.activity-score-input');
			const index = _.findIndex(siblings, e.currentTarget);
			siblings[index + delta]?.focus();
		}
	}

	const score = activity.score !== null ? (Math.round(activity.score * 10) / 10) : null;

	let colour = theme.palette.text.primary;
	let bgColour = '#999';
	if (score !== null) {
		if (score < 50) {
			bgColour = theme.palette.error.main;
		}
		else {
			bgColour = getInterpolatedColor(score, 50, 100);
		}
		colour = theme.palette.getContrastText(bgColour);
	}


	const adornmentSx = {
		ml: 0.5,
		backgroundColor: bgColour,
		color: colour,
	};

	return (
		<OutlinedInput
			sx={{ px: 0.25, minHeight: '20px !important' }}
			defaultValue={activity.scoreRaw}
			placeholder="Score"
			inputProps={{ className:'activity-score-input', style: { width: "3rem", textAlign: "center", padding: 0 } }}
			endAdornment={<InputAdornment sx={adornmentSx} position="end" className="calculated-score">{score !== null ? score + '%' : '--%'}</InputAdornment>}
			onKeyDown={keyDown}
			onChange={(e) => { activity.scoreRaw = e.target.value; debouncedUpdateActivity(activity); }} />
	);
}